module.exports = "//cdn.mxpnl.com/static/asset-cache/25e6f1b705d4c49c474ecf6743b566ba/iron/common/widgets/warning-hero/images/empty-flows.svg";